module.exports = __webpack_public_path__ + "static/media/relative_white.b6e604fd.svg";